import './style/global.less';
import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from '@arco-design/web-react';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import 'animate.css';
import PageLayout from '@/layout/index';
import { GlobalContext } from './context';
import Login from './pages/login/index';
import LoginLoading from './pages/login/loading';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import { observer } from 'mobx-react-lite';
import 'virtual:windi.css';
import { appStore, loginStore, userStore } from './mobx';
import UpgradeModal from './components/UpgradeModal';
import _ from 'lodash';
import { addTab } from '@/pages/matrix/config';
import { setTokenToLocalStorage } from './utils/token';
import usePublishTask from './hooks/usePublishTask';

const App = observer(() => {
  const { connectWebSocket, disconnectWebSocket, wsRef, sendMessage } =
    usePublishTask();
  const [lang, setLang] = useStorage('arco-lang', 'zh-CN');
  const [theme, setTheme] = useStorage('arco-theme', 'light');
  const launchCb = useRef(null);
  const authCb = useRef(null);

  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      case 'en-US':
        return enUS;
      default:
        return zhCN;
    }
  }

  useEffect(() => {
    // setInterval(() => {
    //   sendMessage(101, {});
    // }, 3000);
    if (window.electron) {
      console.log('进入了effect监听===========》');

      launchCb.current = window.electron?.ipcRenderer?.webLaunchReady();
      // 接受网页端拉起的参数
      authCb.current = window.electron.ipcRenderer.launchAuth(
        _.debounce(async (p) => {
          console.log('=========================================>', p);

          const aid = p?.aid;
          const token = p?.token;
          const hasAccountId =
            p?.id !== undefined && p?.id !== null && p?.id !== '';

          if (
            aid == undefined ||
            aid == null ||
            !token ||
            !p.platform_id ||
            !hasAccountId
          ) {
            // Notification.error({
            //   title: '提示',
            //   content: '参数不全，请通过geo网页端调起小助手',
            // });
            return;
          }
          window.launchBy = 'web';
          userStore.setOperatorId(null);
          userStore.setOperatorLogin(false);
          userStore.setCurrentTeam(null);
          // 携带token登录
          if (token) {
            if (aid !== undefined && aid !== null) {
              appStore.setAid(aid);
            }
            loginStore.setLoading(true);
            setTokenToLocalStorage(token);
            const res = await userStore.getUserInfo();
            if (location.pathname === '/login' && res.id) {
              setTimeout(() => {
                console.log('history========>', history);
                location.replace('/matrix');
                loginStore.setLoading(false);
                window.launchBy = '';
              }, 300);
            }
          }

          setTimeout(() => {
            loginStore.setLoading(false);
            window.launchBy = '';
            appStore.setPlatformId(+p.platform_id);
            if (
              p.platform_id &&
              hasAccountId &&
              location.pathname !== '/login'
            ) {
              appStore.setPlatformId(+p.platform_id);
              const platformData = appStore.navList.find(
                (item) => item.meta?.platform === +p.platform_id
              );

              addTab(
                {
                  auth_data: p.cookie,
                  auth_status: 1,
                  platform_id: +p.platform_id,
                  webview_id: p.webview_id,
                  id: +p.id,
                  remark: p.remark,
                },
                platformData
              );
            }
          }, 500);
        }, 500)
      );
    }

    if (userStore.isHydrated) {
      if (localStorage.getItem('Token')) {
        userStore.getUserInfo();
      } else if (window.location.pathname.replace(/\//g, '') !== 'login') {
        window.location.pathname = '/login';
      }
    }

    return () => {
      if (window.electron) {
        window.electron.ipcRenderer.removeListener(
          'web-launch-ready',
          launchCb.current
        );

        window.electron.ipcRenderer.removeListener(
          'launch-auth',
          authCb.current
        );
      }
    };
  }, [userStore.isHydrated]);

  useEffect(() => {
    if (!window.electron || !userStore.isHydrated) return;

    connectWebSocket();
    return () => {
      disconnectWebSocket();
    };
  }, [userStore.isHydrated, userStore.agent_id, appStore.aid]);

  useEffect(() => {
    if (appStore.aid !== undefined && appStore.aid !== null) {
      appStore.getConfig();
    }
  }, [appStore.aid]);

  useEffect(() => {
    changeTheme(theme);
  }, [theme]);

  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme,
  };

  return (
    <BrowserRouter>
      <ConfigProvider
        locale={getArcoLocale()}
        componentConfig={{
          Card: {
            bordered: false,
          },
          List: {
            bordered: false,
          },
          Table: {
            border: false,
          },
        }}
      >
        <GlobalContext.Provider value={contextValue}>
          <Switch>
            <Route
              path="/login"
              component={
                // process.env.NODE_ENV === 'development'
                //   ? Login
                //   : LoginLoading
                Login
              }
            />
            <Route path="/" component={PageLayout} />
          </Switch>
        </GlobalContext.Provider>
      </ConfigProvider>

      {process.env.NODE_ENV !== 'development' ? <UpgradeModal /> : null}
    </BrowserRouter>
  );
});

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
